import type { LabelHTMLAttributes, ReactNode } from 'react'

import type { SerializedStyles, Theme } from '@emotion/react'

import { Typography } from '../typography'

import * as styles from './input-label.styles'

export type InputLabelProps = {
  children: ReactNode | string
  flexible?: boolean
  focused?: boolean
  disabled?: boolean
  variant?: 'default' | 'mini'
  css?: Array<SerializedStyles | undefined> | SerializedStyles
} & LabelHTMLAttributes<HTMLLabelElement>

export const InputLabel = ({
  children,
  flexible = false,
  focused = false,
  disabled = false,
  ...props
}: InputLabelProps) => {
  const showPlaceholder = flexible && !focused

  const labelStyles = (theme: Theme) => [
    styles.root(theme),
    disabled && styles.disabled(theme),
  ]

  const wrapperStyles = (theme: Theme) => [
    styles.wrapper,
    showPlaceholder && styles.flexibleWrapper(theme),
  ]

  const textStyles = (theme: Theme) => [
    styles.textTransition(theme),
    showPlaceholder && styles.placeholder,
  ]

  return (
    <label css={labelStyles} data-testid="input-label" {...props}>
      <div css={wrapperStyles}>
        <Typography css={textStyles} variant="b3">
          {children}
        </Typography>
      </div>
    </label>
  )
}
